(function () {
  function getCards(track) {
    return Array.prototype.slice.call(track.querySelectorAll("[data-cart-upsell-personal-card]"));
  }

  function getActiveIndex(track) {
    var cards = getCards(track);
    var activeIndex = 0;
    var smallestDistance = Infinity;

    cards.forEach(function (card, index) {
      var distance = Math.abs(card.offsetLeft - track.scrollLeft);

      if (distance < smallestDistance) {
        smallestDistance = distance;
        activeIndex = index;
      }
    });

    return activeIndex;
  }

  function updateDots(upsell) {
    var track = upsell.querySelector("[data-cart-upsell-personal-track]");
    var dots = Array.prototype.slice.call(upsell.querySelectorAll("[data-cart-upsell-personal-dot]"));

    if (!track || dots.length === 0) {
      return;
    }

    var activeIndex = getActiveIndex(track);

    dots.forEach(function (dot, index) {
      dot.setAttribute("aria-current", index === activeIndex ? "true" : "false");
    });
  }

  function scrollToIndex(track, index) {
    var cards = getCards(track);
    var targetCard = cards[index];

    if (!targetCard) {
      return;
    }

    track.scrollTo({
      left: targetCard.offsetLeft,
      behavior: "smooth"
    });
  }

  document.addEventListener("click", function (event) {
    var arrow = event.target.closest(".cart-upsell-personal__arrow");
    var dot = event.target.closest("[data-cart-upsell-personal-dot]");

    if (!arrow && !dot) {
      return;
    }

    var upsell = event.target.closest(".cart-upsell-personal");
    var track = upsell && upsell.querySelector("[data-cart-upsell-personal-track]");

    if (!track) {
      return;
    }

    if (arrow) {
      var direction = arrow.classList.contains("cart-upsell-personal__arrow--prev") ? -1 : 1;
      var cards = getCards(track);
      var targetIndex = (getActiveIndex(track) + direction + cards.length) % cards.length;

      scrollToIndex(track, targetIndex);
    }

    if (dot) {
      var dots = Array.prototype.slice.call(upsell.querySelectorAll("[data-cart-upsell-personal-dot]"));
      scrollToIndex(track, dots.indexOf(dot));
    }
  });

  document.addEventListener("scroll", function (event) {
    var track = event.target.closest && event.target.closest("[data-cart-upsell-personal-track]");

    if (!track) {
      return;
    }

    var upsell = track.closest(".cart-upsell-personal");

    window.requestAnimationFrame(function () {
      updateDots(upsell);
    });
  }, true);

  document.addEventListener("cart-drawer:refreshed", function (event) {
    event.target.querySelectorAll(".cart-upsell-personal").forEach(updateDots);
  });

  document.querySelectorAll(".cart-upsell-personal").forEach(updateDots);
})();
